module.exports = __webpack_public_path__ + "static/media/icr_logo_yellow.aa29271e.png";